import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dev-func-action-host]',
    standalone: false
})
export class DevFuncActionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}